import React from 'react';
import '../less/credits_list.less';


import clearBR from "../../../../../helpers/utils/clearBR";
import {Link} from 'MWC';

export default function template() {
    const {className, isMobile, page, data} = this.props;

    const items = data.items.map(item => {
        const text = isMobile ? clearBR(this.l10n(item.credit_text)) : this.l10n(item.credit_text)

        ;
        return (
            <div key={item.title} className={`${className}-item items-wrapper-item`}>
                <div className="left-side">
                    <div className="item-credit-title title" dangerouslySetInnerHTML={{ __html:this.l10n(item.credit_title)}}></div>
                    <div className="item-credit-text" dangerouslySetInnerHTML={{ __html: text}}></div>
                </div>
                <div className="right-side">
                    <div className="terms">
                        <div className="terms-item">
                            <div className="item-title" dangerouslySetInnerHTML={{ __html:this.l10n(item.term_1)}}></div>
                            <div className="item-text" dangerouslySetInnerHTML={{ __html:this.l10n('CREDITS_LIST_CREDIT_TERM_1_1_1')}}></div>
                        </div>
                        <div className="terms-item">
                            <div className="item-title" dangerouslySetInnerHTML={{ __html:this.l10n(item.term_2)}}></div>
                            <div className="item-text" dangerouslySetInnerHTML={{ __html:this.l10n('CREDITS_LIST_CREDIT_TERM_1_2_2')}}></div>
                        </div>
                        <div className="terms-item">
                            <div className="item-title" dangerouslySetInnerHTML={{ __html:this.l10n(item.term_3)}}></div>
                            <div className="item-text" dangerouslySetInnerHTML={{ __html:this.l10n(item.term_3_3)}}></div>
                        </div>
                    </div>

                    <Link href={this.l10n(item.url)}>
                        <button className='btn'>
                            {this.l10n('CREDITS_ITEM_BUTTON')}
                        </button>
                    </Link>
                </div>
            </div>
        )
    });


    return (
        <div className={`${page}-wrapper`}>
            <div className="title">{this.l10n(data.title)}</div>
            <div className={`${className} items-wrapper`}>{items}</div>

        </div>
    );
}
